import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Crown, Gamepad2 } from 'lucide-react';
import { publicApi } from '../api';

export const TodayTopPlayer = () => {
  const [top, setTop] = useState(undefined);

  useEffect(() => {
    publicApi.getTodayTop()
      .then((r) => setTop(r.top))
      .catch((e) => { console.warn('[today-top] load failed', e); setTop(null); });
  }, []);

  if (top === undefined) return <div data-testid="today-top-loading" className="mt-6 h-20 max-w-md rounded-2xl bg-white/50 animate-pulse" />;

  return (
    <div data-testid="today-top-card" className="mt-6 max-w-md flex items-center gap-4 bg-white rounded-2xl border-2 border-[#1a1a1a] crunch-shadow-sm p-4">
      <div className="w-12 h-12 shrink-0 rounded-full bg-[#1a1a1a] text-[#FFD84D] flex items-center justify-center">
        <Crown size={22} />
      </div>
      {top ? (
        <div className="min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-widest text-[#E63946]">Today's top player</div>
          <div className="flex items-baseline gap-3">
            <span data-testid="today-top-name" className="font-display text-2xl uppercase truncate">{top.name}</span>
            <span data-testid="today-top-score" className="font-display text-2xl">{top.score.toLocaleString('en-IN')}</span>
          </div>
        </div>
      ) : (
        <div className="flex-1 flex flex-wrap items-center justify-between gap-3">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-widest text-[#E63946]">Today's top player</div>
            <div data-testid="today-top-empty" className="font-brico font-bold">No champion yet today. Be the first!</div>
          </div>
          <Link to="/play" data-testid="today-top-play-btn" className="btn-chunky primary text-xs"><Gamepad2 size={14} /> Play</Link>
        </div>
      )}
    </div>
  );
};
